(() => {
  const root = document.querySelector('[data-sv-lens-drawer]');
  if (!root) return;
  const panel = root.querySelector('.sv-lens-drawer__panel');
  const open = root.querySelector('[data-sv-lens-open]');
  const closers = [...root.querySelectorAll('[data-sv-lens-close]')];
  const backdrop = root.querySelector('.sv-lens-drawer__backdrop');
  const image = root.querySelector('[data-sv-lens-image]');
  const label = root.querySelector('[data-sv-lens-label]');
  const copy = root.querySelector('[data-sv-lens-copy]');
  const choices = [...root.querySelectorAll('[data-sv-lens-choice]')];
  let previousFocus = null;
  let hasPreloaded = false;

  const focusableSelector = 'button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])';
  const getFocusable = () => [...panel.querySelectorAll(focusableSelector)].filter(el => !el.disabled && el.offsetParent !== null);

  const preload = () => {
    if (hasPreloaded) return;
    hasPreloaded = true;
    choices.forEach(b => {
      if (b.dataset.src && image && b.dataset.src !== image.currentSrc && b.dataset.src !== image.src) {
        const i = new Image();
        i.src = b.dataset.src;
      }
    });
  };

  const show = () => {
    previousFocus = document.activeElement;
    root.classList.add('is-open');
    panel?.setAttribute('aria-hidden', 'false');
    open?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('sv-lens-drawer-open');
    if (backdrop) backdrop.hidden = false;
    preload();
    window.setTimeout(() => root.querySelector('[data-sv-lens-close]')?.focus(), 60);
  };

  const hide = () => {
    root.classList.remove('is-open');
    panel?.setAttribute('aria-hidden', 'true');
    open?.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('sv-lens-drawer-open');
    if (backdrop) backdrop.hidden = true;
    previousFocus?.focus?.();
  };

  const trapFocus = (e) => {
    if (!root.classList.contains('is-open') || e.key !== 'Tab') return;
    const nodes = getFocusable();
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  open?.addEventListener('click', () => root.classList.contains('is-open') ? hide() : show());
  closers.forEach(x => x.addEventListener('click', hide));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && root.classList.contains('is-open')) hide();
    trapFocus(e);
  });

  choices.forEach(button => button.addEventListener('click', () => {
    choices.forEach(x => {
      const active = x === button;
      x.classList.toggle('is-active', active);
      x.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    const src = button.dataset.src || '';
    if (image && src) {
      image.style.opacity = '.2';
      const pre = new Image();
      pre.onload = () => {
        image.src = src;
        image.alt = button.dataset.alt || button.dataset.label || '';
        image.style.opacity = '1';
      };
      pre.src = src;
    }
    if (label) label.textContent = button.dataset.label || '';
    if (copy) copy.textContent = button.dataset.copy || '';
  }));
})();
